import { GetLatestEventsResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { UseLatestEventsPayload } from './use-latest-events-types';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useLatestEvents(payload: UseLatestEventsPayload) {
  return useQuery(
    queryKeys.events(payload),
    async ({ signal }) => {
      const privateApi = getPrivateApi();
      const getLatestEventsResponse = await privateApi.getLatestEvents(
        {
          ...payload,
        },
        { signal },
      );

      return GetLatestEventsResponseSchema.parse(getLatestEventsResponse);
    },
    {
      keepPreviousData: true,
    },
  );
}
